let scrollTimer = null;

const page = {
    // 滚动聊天列表到底部
    scrollChatListDown: (pos, initCount) => {
        let dom = document.getElementById('wusong-im-chat-list');
        if (!dom) {
            return;
        }
        let maxCount = 5;
        initCount = initCount || 1;
        if (typeof pos !== 'number') {
            pos = Math.max(dom.scrollHeight - dom.clientHeight, 888888);
        }
        dom.scrollTop = pos;
        if (dom.scrollTop < pos && initCount < maxCount) {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                initCount++;
                page.scrollChatListDown(pos, initCount);
            }, 200);
        }
    },
    getChatListHeight: () => {
        return document.getElementById('wusong-im-chat-list').scrollHeight;
    },
    getChatListScroll: () => {
        return document.getElementById('wusong-im-chat-list').scrollTop;
    },
};

export default page;
